import React from 'react'
import { useSelector } from 'react-redux'
import { useAnalyticsPageView, usePathParam } from '@chilecompra/react-kit'
import { Card, Skeleton, Table, TableRow, Toast, Typography } from '@chilecompra/react-kit/components'
import { checkIfForeignDni } from '../../modules/utils/helpers'
import { Column, Content, Row, TableCell } from './FinancialSuitabilitySection.styles'

/**
 * The Financial Suitability section container.
 */
const FinancialSuitabilitySection = () => {
  const dni = usePathParam('rut')
  const isForeign = checkIfForeignDni(dni)
  const { error, lastDeclaredPeriod, loading, orgSizeDetails, orgSizeLabel } = useSelector(
    state => state.financialSuitability
  )

  useAnalyticsPageView('/ficha/idoniedad')
  return (
    <Content>
      <Card color="blank" enableBorder padding="32px 24px 8px">
        <Row>
          <Column width="200px">
            <Typography fontWeight="bold" padding="0 0 3px" variant="h4">
              Situación financiera
            </Typography>
            <Typography variant="subtitle">Fuente: Servicio de Impuestos Internos</Typography>
          </Column>

          {!error && !isForeign && (
            <Column flexBasis="60%" flexGrow={2}>
              <Table accessibility={{ label: 'Situación financiera' }}>
                <TableRow>
                  <TableCell enableHead padding="0 8px 8px 0" width="150px">
                    Tamaño de la empresa
                  </TableCell>
                  <TableCell padding="0 0 8px 8px">
                    <Typography variant="body2">
                      {loading ? (
                        <Skeleton width="100%" />
                      ) : orgSizeLabel ? (
                        `${orgSizeLabel} - ${orgSizeDetails}`
                      ) : (
                        'Sin información'
                      )}
                    </Typography>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell disableBottomBorder enableHead>
                    Declaración anual de renta
                  </TableCell>
                  <TableCell disableBottomBorder>
                    <Typography variant="body2">
                      {loading && <Skeleton width="100%" />}
                      {!loading &&
                        (orgSizeDetails === 'Sin información'
                          ? `No registra información para el periodo ${lastDeclaredPeriod}`
                          : `Último periodo declarado ${lastDeclaredPeriod}`)}
                    </Typography>
                  </TableCell>
                </TableRow>
              </Table>
            </Column>
          )}

          {!error && isForeign && (
            <Column flexBasis="60%" flexGrow={2}>
              <Table accessibility={{ label: 'Información del proveedor' }}>
                <TableRow>
                  <TableCell padding="0 0 8px">
                    <Typography variant="body2">Sin información disponible.</Typography>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell disableBottomBorder padding="12px 0 16px">
                    <Typography variant="subtitle">
                      No tenemos información disponible de esta empresa proveedora extranjera.
                    </Typography>
                  </TableCell>
                </TableRow>
              </Table>
            </Column>
          )}

          {!loading && error && (
            <Column flexBasis="60%" flexGrow={2}>
              <Toast
                disableBackground
                margin="-9px 0 0 -17px"
                severity="default"
                title="Lo sentimos, estamos presentando problemas con nuestro servidor."
              >
                En estos momentos tenemos problemas para disponibilizar la información. Por favor, consulta en unos
                minutos más.
              </Toast>
            </Column>
          )}
        </Row>
      </Card>
    </Content>
  )
}

export default FinancialSuitabilitySection
